import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useStateContext } from "../../../../../../Context/StateContext";

export default function IndustryOptionForPosts({ values, filter }) {
  const [allSkills, setAllSkills, ] = useState([]);
  const [selectSkills, setSelectSkills] = useState(null);
  const { state, setIndustries, setKeywords , setSubcategories} = useStateContext();
  const { industries } = state;

  useEffect(() => {
    setAllSkills(values);
  }, [values]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    const updatedSkills = [...industries, newLanguage];
    setIndustries(updatedSkills);
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = industries.filter(
      (language) => language.id !== id
    );
    setIndustries(updatedLanguages);
    setKeywords([])
    setSubcategories([])
  };

  return (
    <div>
      <ReactSelect
        options={
          Array.isArray(allSkills) &&
          allSkills
            .filter((lang) => {
              return (
                Array.isArray(industries) &&
                !industries.some((selectedLang) => selectedLang.id === lang.id)
              );
            })
            .map((lang) => ({ value: lang.id, label: lang.title }))
        }
        placeholder={`Select ${filter.title}`}
        value={selectSkills}
        isClearable={true}
        onChange={(options) => {
          if (options) {
            handleLanguageChange(options);
          }
        }}
      />

      <div className="add-skills">
        {Array.isArray(industries) &&
          industries.map((skills, index) => (
            <div key={index}>
              <p onClick={() => handleDeleteLanguage(skills.id)}>
                {skills.title} <span>x</span>
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
